// @flow
import * as React from 'react';
import { Box, Stack, Text, TextField } from '@locus-taxy/neo-ui';

import {
    rankWith,
    uiTypeIs,
    useViewProps,
    type Tester
} from 'platform/settings/form/JsonView';

type Props = {};

const PreviewTextInputView = (props: Props): React.Node => {
    const { label, data } = useViewProps(props);

    const [valueToPreview] = data || [];

    const [value, setValue] = React.useState(valueToPreview);

    return (
        <Stack space="xxSmall">
            <Box
                borderBottomStyle="solid"
                borderWidth="thin"
                borderColor="grey.200"
            />

            <Text size="regular" color="grey.900" fontWeight="bold">
                {label}:
            </Text>

            <TextField
                value={value ?? ''}
                fullWidth
                onChange={value => setValue(value)}
            />
        </Stack>
    );
};

export default PreviewTextInputView;

export const previewTextInputViewTester: Tester = rankWith(
    1,
    uiTypeIs('PreviewTextInputView')
);
